import React from "react";
import { Link } from "react-router-dom";
import { loginimg, loginlog } from "../Constant/Index";

function Signup() {
  return (
    <>
      {/* Sign up Section  */}
      <section className="login_sec overflow-hidden">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="auth_form">
              {/* <div className="mobileLogo">
                <Link to="/">
                  <figure>
                    <img src={logo} alt="weblogo" className="img-fluid" />
                    dddd
                  </figure>
                </Link>
              </div> */}
              <div className="heading_wrapper">
                <div className="webLogo">
                  <Link to="/">
                    <figure>
                      <img src={loginlog} alt="weblogo" className="img-fluid" />
                    </figure>
                  </Link>
                </div>
                <p className="tagline secondary-color font-weight-bold">
                  Powerful Hand
                </p>

                <h2 className="title primary-color">Sign Up</h2>
                <p className="primary-color font-weight-meduim">
                  Welcome to Powerful Hand, your multi-lingual E-Commerce
                  destination for ritual and spiritual products. From candles to
                  sacred herbs, we offer a diverse range catering to global
                  practices.
                </p>
              </div>
              <form>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      {/* <label className="form-label">Email Address</label> */}

                      <input
                        required
                        type="text"
                        placeholder="First Name"
                        name="First Name"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      {/* <label className="form-label">Email Address</label> */}

                      <input
                        required
                        type="text"
                        placeholder="Last Name"
                        name="Last Name"
                        // onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      {/* <label className="form-label">Email Address</label> */}
                      <input
                        required
                        type="email"
                        placeholder="Email Address"
                        name="password"
                        // onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      {/* <label className="form-label">Email Address</label> */}

                      <input
                        required
                        type="number"
                        placeholder="Contact Number"
                        name="password"
                        // onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      {/* <label className="form-label">Email Address</label> */}

                      <input
                        required
                        type="password"
                        placeholder="Password"
                        name="password"
                        // onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                      />
                      <div className="eye-icon" style={{right: "10px"}}>
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      {/* <label className="form-label">Email Address</label> */}
                      <input
                        required
                        type="password"
                        placeholder="Confirm Password"
                        name="password"
                        // onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                      />
                      <div className="eye-icon"style={{right: "10px"}}> 
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="button-group">
                  <button className="milkyBtn w-100">Sign Up</button>
                </div>
                <div className="signup-span">
                  <p className="primary-color font-weight-semibold">
                    Already Have An Account ?{" "}
                    <span>
                      <Link to="/login">Sign in</Link>
                    </span>
                  </p>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="showcase_column">
              {/* <div className="webLogo">
                <Link to="/">
                  <figure>
                    <img src={loginimg} alt="weblogo" className="img-fluid" />
                  </figure>
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      {/* ============================= */}
    </>
  );
}

export default Signup;
